/* eslint-disable no-lonely-if */
/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { DateRangePicker } from 'react-dates';
import ptLocale from 'moment/locale/pt-br';
import moment from 'moment';
import {
  setActivityDate, setDate, getActivitiesByTypeAndDate, getOas,
} from '../../actions';
import Close from '../../assets/cross-icon.svg';
import SelectedIcon from '../../assets/selected-icon.svg';
import CalendarIcon from '../../assets/calendar-icon.svg';

import './Filter.css';

moment.updateLocale('pt-br', ptLocale);

const Filter = (props) => {
  const today = moment();

  const [dropdownActive, setDropdownActive] = useState(false);
  const [activeDate, setActiveDate] = useState([]);
  const [selectedDate, setSelectedDate] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [focusedInput, setFocusedInput] = useState('startDate');
  const [datepickerStatus, setDatepickerStatus] = useState(false);


  useEffect(() => {
    const newActiveDate = [];
    if (props.activity) {
      props.activityDate.map((el) => newActiveDate.push(el.value));
    } else {
      props.oaActivityDate.map((el) => newActiveDate.push(el.value));
    }
    setSelectedDate([]);
    setActiveDate(newActiveDate);
    const [propStartDate, propEndDate] = newActiveDate;
    if (propStartDate) {
      setStartDate(moment(propStartDate, 'DD/MM/YYYY'));
    }
    if (propEndDate) {
      setEndDate(moment(propEndDate, 'DD/MM/YYYY'));
    }
  }, [props.activityDate, props.oaActivityDate, props.activity]);

  const handleSearch = () => {
    if (props.activity) {
      props.getActivitiesByTypeAndDate();
    } else {
      props.getOas();
    }
  };

  const handleToggleDropdown = () => {
    setDropdownActive(!dropdownActive);
  };

  const handleOptionClick = (opt) => {
    setStartDate(null);
    setEndDate(null);
    if (selectedDate.find((el) => el === opt)) {
      setSelectedDate([]);
    } else {
      setSelectedDate([opt]);
    }
  };

  const handleSave = () => {
    setActiveDate(selectedDate);

    const [startDateToSearch, endDateToSearch] = selectedDate;
    if (props.activity) {
      if (endDateToSearch === 'Invalid date') {
        props.setActivityDate(moment(startDateToSearch, 'DD/MM/YYYY').format('YYYY-MM-DD'));
      } else if (startDateToSearch && endDateToSearch) {
        if (endDateToSearch !== 'Invalid date') {
          props.setActivityDate(moment(startDateToSearch, 'DD/MM/YYYY').format('YYYY-MM-DD'), moment(endDateToSearch, 'DD/MM/YYYY').format('YYYY-MM-DD'));
        }
      } else if (startDateToSearch) {
        if (startDateToSearch === 'ESTA SEMANA') {
          const from = today.startOf('week').format('YYYY-MM-DD');
          const to = today.endOf('week').format('YYYY-MM-DD');
          props.setActivityDate(from, to);
        } else if (startDateToSearch === 'ESTE MÊS') {
          const from = today.startOf('month').format('YYYY-MM-DD');
          const to = today.endOf('month').format('YYYY-MM-DD');
          props.setActivityDate(from, to);
        }
      }
    } else {
      if (endDateToSearch === 'Invalid date') {
        props.setDate(moment(startDateToSearch, 'DD/MM/YYYY').format('YYYY-MM-DD'));
      } else if (startDateToSearch && endDateToSearch) {
        if (endDateToSearch !== 'Invalid date') {
          props.setDate(moment(startDateToSearch, 'DD/MM/YYYY').format('YYYY-MM-DD'), moment(endDateToSearch, 'DD/MM/YYYY').format('YYYY-MM-DD'));
        }
      } else if (startDateToSearch) {
        if (startDateToSearch === 'ESTA SEMANA') {
          const from = today.startOf('week').format('YYYY-MM-DD');
          const to = today.endOf('week').format('YYYY-MM-DD');
          props.setDate(from, to);
        } else if (startDateToSearch === 'ESTE MÊS') {
          const from = today.startOf('month').format('YYYY-MM-DD');
          const to = today.endOf('month').format('YYYY-MM-DD');
          props.setDate(from, to);
        }
      }
    }


    setDropdownActive(!dropdownActive);

    handleToggleDropdown();

    handleSearch();
  };

  function handleChangeDates(dates) {
    const { startDate: startD, endDate: endD } = dates;
    setStartDate(startD);
    setEndDate(endD);

    const startDateSting = moment(startD).format('DD/MM/YYYY');
    const endDateString = moment(endD).format('DD/MM/YYYY');

    setSelectedDate([startDateSting, endDateString]);
  }
  function handleOpenDatepicker(fI) {
    setDatepickerStatus(true);
    setFocusedInput(fI);
  }
  return (
    <>
      <div className="filter-block">
        <div
          className={`filter ${activeDate.length <= 0 ? 'empty' : ''}`}
          onClick={handleToggleDropdown}
          role="presentation"
        >
          <div className="d-flex justify-content-center elipsis">
            {

              activeDate <= 0 ? (
                <p>DATA</p>
              ) : (
                activeDate.map((date, index) => (
                  <>
                    <p key={Math.random()}>
                      {date}
                    </p>
                    {(index < activeDate.length - 1) && <p>-</p>}
                  </>
                ))
              )
            }
          </div>
        </div>
        <div className={`dropdown container ${dropdownActive ? 'active ' : ''}`}>
          <img src={Close} alt="Fechar" className="pt-4 close-icon pb-4" role="presentation" onClick={handleToggleDropdown} />
          <div className={`options  ${datepickerStatus && 'datepicker'}`}>
            <div
              className={`option-block ${selectedDate.find((el) => el === 'ESTA SEMANA') && 'active'}`}
              onClick={() => handleOptionClick('ESTA SEMANA')}
              role="presentation"
            >
              <p className="option-name">
                ESTA SEMANA
              </p>
              <img
                src={SelectedIcon}
                alt="Ativo"
              />
            </div>
            <hr />
            <div
              className={`option-block ${selectedDate.find((el) => el === 'ESTE MÊS') && 'active'}`}
              onClick={() => handleOptionClick('ESTE MÊS')}
              role="presentation"
            >
              <p className="option-name">
                ESTE MÊS
              </p>
              <img
                src={SelectedIcon}
                alt="Ativo"
              />
            </div>
            <hr />
            <div className="pb-3">
              <DateRangePicker
                readOnly
                startDate={startDate}
                startDateId="s_date"
                endDate={endDate}
                endDateId="e_date"
                onDatesChange={(sD, eD) => handleChangeDates(sD, eD)}
                focusedInput={focusedInput}
                onFocusChange={(fI) => handleOpenDatepicker(fI)}
                orientation="vertical"
                startDatePlaceholderText="De data"
                endDatePlaceholderText="Até data"
                onClose={() => setDatepickerStatus(false)}
                customInputIcon={<img src={CalendarIcon} alt="Selecione uma data" />}
              />
            </div>

          </div>
          <div className="mt-auto text-center pb-3">
            <button className="btn btn-primary big-button" type="button" onClick={handleSave}>Salvar</button>
          </div>
        </div>
      </div>
      <div className={dropdownActive ? 'backdrop' : ''} role="presentation" onClick={handleToggleDropdown} />
    </>
  );
};

const mapStateToProps = (store) => ({
  activityDate: store.filterState.activityDate,
  oaActivityDate: store.filterState.oaActivityDate,
});
const mapDispatchToProps = (dispatch) => bindActionCreators({
  setActivityDate, getOas, getActivitiesByTypeAndDate, setDate,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Filter);
